import { OktaAuthOptions } from '@okta/okta-auth-js';

export interface EnvAuth extends OktaAuthOptions {
  isActive: boolean;
}
